import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';

function* getServicesApi() {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE.GET_RECORDS())
        yield put(Actions.getServicesApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServicesApiError(getErrorFromResponse(err)));
    }
}

function* upsertServiceApi(action: Actions.upsertServiceSuccessAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE.CREATE, action.service)
        yield put(Actions.upsertServiceApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.upsertServiceApiError(getErrorFromResponse(err)));
    }
}

function* getServiceCategoriesApi() {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CATEGORY.GET_RECORDS())
        yield put(Actions.getServiceCategoriesApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServiceCategoriesApiError(getErrorFromResponse(err)));
    }
}

function* upsertServiceCategoryApi(action: Actions.UpsertServiceCategoryAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE_CATEGORY.CREATE, action.serviceCategory)
        yield put(Actions.upsertServiceCategoryApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.upsertServiceCategoryApiError(getErrorFromResponse(err)));
    }
}

function* getServiceByIdApi(action: Actions.GetServiceByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE.GET_BY_ID(action.serviceId))
        yield put(Actions.getServiceByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServiceByIdApiError(getErrorFromResponse(err)));
    }
}

export default function* serviceSagas() {
    yield takeLatest(ActionTypes.GET_SERVICES_API, getServicesApi)
    yield takeLatest(ActionTypes.UPSERT_SERVICE_API, upsertServiceApi)
    yield takeLatest(ActionTypes.GET_SERVICE_CATEGORIES_API, getServiceCategoriesApi)
    yield takeLatest(ActionTypes.UPSERT_SERVICE_CATEGORY_API, upsertServiceCategoryApi)
    yield takeLatest(ActionTypes.GET_SERVICE_BY_ID_API, getServiceByIdApi)
}